module.exports = __webpack_public_path__ + "img/room-design-competition_inzh.31bcff6a.png";